fragment TeaserWithCtaFragment on teaserWithCta_Entry {
  typeHandle
  heading
  body
  image {
    url
    title
  }
  cta {
    ...LinkFragment
  }
  backgroundGray
}
